module.exports = __webpack_public_path__ + "static/image 98-e57171d45df4a9118fa1e82e5acb2b42.png";